import React from "react";
import Chip from "@material-ui/core/Chip";
import { makeStyles, Typography } from "@material-ui/core";
import { downloadViolationFile } from "../../../../redux/reducers/act-reducer";

const useStyles = makeStyles(() => ({
  chip: {
    minWidth: 160,
    maxWidth: 210,
    marginTop: 10,
    marginBottom: 10,
    marginRight: 10
  },
  header: {
    // paddingBottom: theme.spacing(1),
    fontSize: "1rem",
    fontWeight: 400,
  },
}));

export const ChipBlock = ({
  id,
  setFieldValue,
  sequenceNumber,
  error,
  touched,
  helperText,
  format,
  value,
  ...props
}) => {
  const classes = useStyles();

  const onDownloadFile = async (event) => {
    const filename = event.target.outerText;
    const fileId = value.filter((f) => f.file.name === filename)[0].id;
    await downloadViolationFile(fileId);
  };

  return value.length !== 0 ? (
    <>
      <Typography className={classes.header} variant={"h6"}>
        Загруженные файлы нарушений
      </Typography>
      {value.map((chip, idx) => (
        <Chip
          key={idx}
          className={classes.chip}
          id={chip.id}
          variant={"outlined"}
          size={"medium"}
          error={touched && Boolean(error)}
          {...props}
          label={chip.file?.name}
          onClick={onDownloadFile}
        />
      ))}
    </>
  ) : null;
};
